import { render, staticRenderFns } from "./PreauthAdd.vue?vue&type=template&id=4a48b3f0&scoped=true&"
import script from "./PreauthAdd.vue?vue&type=script&lang=js&"
export * from "./PreauthAdd.vue?vue&type=script&lang=js&"
import style0 from "./PreauthAdd.vue?vue&type=style&index=0&id=4a48b3f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48b3f0",
  null
  
)

export default component.exports